'use strict';

import Employee from './employee/Employee.service'
import Schedule from './employee/Schedule.service'
import Group from './employee/Group.service'
import Education from './employee/Education.service'
import Family from './employee/Family.service'
import Emergency from './employee/Emergency.service'
import WorkingExperience from './employee/WorkingExperience.service'
import BankAccount from './employee/BankAccount.service'
import Address from './employee/Address.service'
import Medical from './employee/Medical.service'
const state = {}

const actions = {
  ...Employee.actions,
  ...Schedule.actions,
  ...Group.actions,
  ...Education.actions,
  ...Family.actions,
  ...Emergency.actions,
  ...WorkingExperience.actions,
  ...BankAccount.actions,
  ...Address.actions,
  ...Medical.actions,
}

const mutations = {}

const getters = {}

export default { getters, actions, mutations, state }